
<template>
    <div class="repair-items app-region blank-t-v blank-l-h blank-r-h">
        <a-table :columns="columns" :data-source="table.data" rowKey="id">
            <span slot="action" slot-scope="text, data">
                <template>
                    <a @click="handleEdit(data)">设置</a>
                </template>
            </span>
        </a-table>


        <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
            destroy-on-close centered :width="1000">
            <a-form-model ref="form" :model="modal.formData" layout="vertical">
                <a-form-model-item label="名称">
                    <a-input v-model="modal.formData.title" disabled></a-input>
                </a-form-model-item>
                <a-form-model-item label="值">
                    <a-input v-model="modal.formData.value" placeholder="请输入值"></a-input>
                </a-form-model-item>
            </a-form-model>
        </a-modal>

    </div>
</template>
  
<script>
import { TJListMixin } from '@/mixins/list.js'
import PaymentSettingService from '@/io/payment/setting.js'
export default {
    mixins: [TJListMixin],
    components: {
    },
    data() {
        return {
            table: {
                data: []
            },
            columns: [
                {
                    title: "id",
                    dataIndex: "id",
                },
                {
                    title: "名称",
                    dataIndex: "title",
                },
                {
                    title: "值",
                    dataIndex: "value",
                },
                {
                    title: "说明",
                    dataIndex: "remark",
                },
                {
                    title: "操作",
                    key: "action",
                    scopedSlots: { customRender: "action" },
                },

            ],
            modal: {
                title: '缴费设置',
                loading: false,
                show: false,
                formData: {
                    id: '',
                    title: '',
                    value: ''
                }
            }
        };
    },
    mounted() {
        this.getLists()
    },
    actived() {
        this.getLists()
    },
    methods: {
        getLists() {
            PaymentSettingService.list().then(res => this.table.data = res)
        },
        handleEdit(row) {
            this.modal.formData = { ...row }
            this.modal.show = true

        },
        confirmModal() {
            this.$beforeFormSubmit(this.$refs.form, async () => {
                this.modal.loading = true
                await PaymentSettingService.edit(this.modal.formData)
                this.$afterFormSubmit("设置成功", () => {
                    this.getLists()
                    this.modal.show = false
                    this.modal.loading = false
                });
            });
        }
    },
};
</script>
<style scoped lang="less"></style>
  